/**
 * @Author: memo
 * @Date:   2020-02-16T14:47:41-06:00
 * @Email:  g.correa@kimeras-studio.com
 * @Project: Farmazon API
 * @Last modified by:   memo
 * @Last modified time: 2020-02-16T15:31:48-06:00
 * @License: MIT
 */



import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";

const PrivateRoute = ({ component: Component, auth, ...rest }) => (
	<Route
		{...rest}
		render={props =>
			auth.isAuthenticated === true ? (
				<Component {...props} />
			) : (
				<Redirect to="/" />
			)
		}
	/>
);

PrivateRoute.propTypes = {
	auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
	auth: state.auth
});

export default connect
	(mapStateToProps)(PrivateRoute);
